export default "__VITE_ASSET__0sDcaj3l__"